import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "card-folder",
  templateUrl: "./card-folder.component.html",
  styleUrl: "./card-folder.component.scss",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardFolderComponent {}
